import logo from 'assets/safi.png';
import { Box, Container, Grid, Stack, Typography, useBreakpoint } from 'ui';

import { FormContainer, MessageContainer } from './styles';

export const AuthLayout = ({
  children,
  title,
  subtitle,
}: {
  title: string;
  subtitle: string;
  children: React.ReactNode;
}) => {
  const { isMobile } = useBreakpoint();

  return (
    <Container>
      <Grid container height="100dvh" alignItems="center">
        {!isMobile && (
          <Grid item xs={6}>
            <MessageContainer isMobile={isMobile}>
              <Typography variant="h3" fontWeight="bold" gutterBottom>
                {title}
              </Typography>
              <Typography variant="body1">{subtitle}</Typography>
            </MessageContainer>
          </Grid>
        )}
        <Grid item xs={isMobile ? 12 : 6} height={isMobile ? 'auto' : '100%'}>
          <FormContainer isMobile={isMobile}>
            <Stack direction="column" gap={2.5} width="100%">
              <Box mb={2.5}>
                <img src={logo} alt="Safi logo" width="80px" />
              </Box>
              {children}
            </Stack>
          </FormContainer>
        </Grid>
      </Grid>
    </Container>
  );
};
